import routes from 'global/Constants/routes';
import { lazy } from 'react';

const ForgetPassword = lazy(() => import('../../pages/forgetPassword/ForgetPassword'));

export const forgetPasswordRoutes = (hasAccessLevel: (_level: number) => boolean) => [
  {
    path: routes.forgetPassword.path,
    component: ForgetPassword,
    isPrivate: routes.forgetPassword.isPrivate,
    accessRole: hasAccessLevel(10),
  },
];
